<template>
  <div class="model">
		<div class="model_box" >
			<div class="model_title">
				<div>
					<img src="../../assets/quan.jpg" >
					转换您的2D设计图到3D可打印格式
					</div>
				<el-tooltip class="item" effect="dark" content="支持jpg、png、jpeg、gif格式" placement="bottom-end">
				   <i class="el-icon-question"></i>
				  </el-tooltip>
			</div>
			<div class="model_content"
			v-loading="loading"
			:element-loading-text="loadingStr"
			element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.8)">
				<!-- <div class="model_img">
					<p v-if="dialogVisible">平面设计图预览</p>
					<img :src="imageUrl" style="position: absolute;width: 100%;height: 100%;top: 0;"  v-if="!dialogVisible">
				</div> -->
				<el-tooltip class="item" effect="dark" content="导出STL" placement="bottom-end" v-if="downVisibleBtn">
				 <a class="model_upload" @click='downLoadFile'>
				 	<img src="../../assets/xz.png" >
				 </a>
				  </el-tooltip>
				  <div v-show="dialogVisibleBtn">
					  <input type="file"
							 id="file"
							 accept="image/.jpg/.png/.jpeg/.gif"
							 ref="inputFile"
							 @change="getPicture($event)">
					 <button  class="upload-demo upload_Btn" @click="callFile"
							  >
							  <i class="el-icon-upload2"></i>
							  上传图片
				     </button>
				  </div>
				  <div v-if="!dialogVisibleBtn" >
					 <el-button size="medium" type="primary" class="upload-demo upload_Btn" @click='handleUpload($event)'>
					 	  <i class="el-icon-upload2"></i>
					 	  转化图片</el-button> 
					
					<i class="el-icon-close upload-demo1" @click="handleDel()">
					</i>
				  </div>
				<!-- <el-upload
				v-if="dialogVisibleBtn"
				  class="upload-demo"
				  action="/image2stl"
				  :before-upload="beforeAvatarUpload"
				  :on-success="handleAvatarSuccess"
				  :file-list="fileList"
				  :show-file-list='false'
				>
				  <el-button size="medium" type="primary" class="upload_Btn">
					  <i class="el-icon-upload2"></i>
					  上传图片</el-button>
				</el-upload> -->
					<!-- <el-button v-else size="medium" type="primary" class="upload-demo upload_Btn" @click='handleUpload'>
						  <i class="el-icon-upload2"></i>
						  转化图片</el-button> -->
				 <el-image 
					v-if='dialogVisible'
				    fit='contain'
					 style="width: 970px;height: 700px;"
				    :src="imageUrl" 
				    :preview-src-list="srcList"
					>
				  </el-image>
				<!-- <img src="../../assets/modelBg.jpg"   > -->
				<model-stl :src="dialogImageUrl"  class='model_stl' v-else ></model-stl>
			</div>
			
		</div>
	
  </div>
</template>

<script>
import { ModelStl } from "vue-3d-model";
import axios from "axios";
 import {
       uploadImage
    } from '../../utils/interface';

  export async function getFile(url) {
  return await new Promise(async function (resolve, reject) {
    await axios({
      method: "get",
      url,
      responseType: "blob",
    })
      .then((data) => {
        resolve(data.data);
      })
      .catch((error) => {
        reject(error.toString());
      });
  });
}
export default {
  components: {
        ModelStl,
    },
  data() {
    return {
		imageUrl:require('../../assets/modelBg.jpg'),
		srcList:[],
		headers: {
		  Authorization: "Bearer " + this.$cookies.get("api_access_token"), //	可以是授权凭证用的参数值
		},
		loading:false,
		// 关于文件上传
		fileList: [],
		dialogImageUrl:'',
		dialogVisible:true,
		dialogVisibleBtn:true,
		downVisibleBtn:true,
		fileName:'',
		errFlag:true,
		loadingStr:'',
		showInputImg:true,
    };
  },
  created() {
  },

  mounted() {
     
  },

  methods: {
	  //导出
	  downLoadFile() {
	  		  let url = this.dialogImageUrl;
	  		  if(this.dialogImageUrl == ''){
	  			  return this.$message.warning('请先上传图片');
	  		  }
	  		  // let url ='https://zengcaicloud.obs.cn-east-2.myhuaweicloud.com/mesh/stl/2d76763a4b64e1f988b75e0c67188d24.stl'
	    getFile(url).then((res) => {
	      let blob = new Blob([res], { type: "application/octet-stream" });
	      // console.log(window.navigator.msSaveOrOpenBlob);
	      if (window.navigator.msSaveOrOpenBlob) {
	        //msSaveOrOpenBlob方法返回bool值
	        navigator.msSaveBlob(blob, this.fileName); //本地保存
	      } else {
	        let link = document.createElement("a"); //a标签下载
	        link.href = window.URL.createObjectURL(blob);
	        link.download = this.fileName;
	        link.click();
	        window.URL.revokeObjectURL(link.href);
	      }
	    });
	  },
	   //预览图片
	  getPicture (e) {
	  		      //预览图片
				  console.log(e)
				  var _this = this;
				  _this.imageUrl = ''
				  _this.srcList=[];//清空预览数组
				  //校验是否通过
				  if(_this.beforeAvatarUpload(e.target.files[0]) === true){
					  _this.loading = false;//关闭loading
					  _this.imageUrl = window.URL.createObjectURL(e.target.files[0]);//本地图片获取
					  console.log(_this.imageUrl)
					  _this.srcList.push(_this.imageUrl)//添加至预览数组
					  _this.dialogVisibleBtn = false;//上传图片按钮消失变成转换图片
					_this.dialogVisible = true;
					_this.downVisibleBtn = false;
				  }
	  		    },
			 //预览图片按钮
			 callFile () {
			  //点击添加图片按钮，触发type:"file"的input标签
			  this.$refs.inputFile.value = ''
			  if(!this.dialogVisibleBtn) return
			  let fileDom = document.querySelector("#file")
			  fileDom.click()
			},
	
	 //转化图片
	 handleUpload(e){
		this.loading = true;
		this.loadingStr = '图片转化中'
		
		//将图片格式转成二进制
		 const myformdataFile = new FormData()
		 //如果有图片
		 if(this.$refs.inputFile.files.length>0){
			myformdataFile.append('file',this.$refs.inputFile.files[0])
		 }else{
			 this.$message.warning('未获取到图片，请重新上传')
			this.dialogVisibleBtn = true;
			this.dialogVisible = true;
			this.imageUrl = require('../../assets/modelBg.jpg');
		 }
		 axios.post("/image2stl", myformdataFile)
			 .then((res) => {
				 console.log(res)
			   if (res.data.success) {
				 this.loading = false;
				 this.dialogImageUrl = res.data.url;
				 this.fileName =res.data.filename;
				 this.dialogVisibleBtn = true;
				 this.dialogVisible = false;
				 this.downVisibleBtn = true;
			   }else{
				   this.$message.error(res.data.message)
				    this.loading = false;
					this.dialogVisibleBtn = true;
					this.dialogVisible = true;
					this.downVisibleBtn = true;
					this.imageUrl = require('../../assets/modelBg.jpg');
			   }
			 });
	 },
	
   beforeAvatarUpload(file){
	   console.log(file)
	   this.loading = true;
	   this.loadingStr = '图片上传中'
	   let fileTypes = [
	   	".jpg",
	   	".png",
	   	".jpeg",
	   	".gif",
	   ];
	   let fileName = file.name.lastIndexOf(".");
	   const fileNameLen = file.name.length;
	   const fileTypeName = file.name.substring(fileName, fileNameLen);
	   let fileIndex = fileTypes.indexOf(fileTypeName);
	   if (fileIndex === -1) {
	   	this.$alert("只支持jpg、png、jpeg、gif格式", "提示", {
	   		confirmButtonText: "确定",
	   	});
		this.loading = false;
		this.imageUrl = require('../../assets/modelBg.jpg');
		this.dialogVisibleBtn = true;
		this.downVisibleBtn = true;
		this.dialogVisible = true;
		this.dialogImageUrl =''
		
	   }
	   return fileIndex !== -1;
   },
   //删除
   handleDel(){
	   this.imageUrl = require('../../assets/modelBg.jpg');
	   this.dialogVisibleBtn = true;
	   this.downVisibleBtn = true;
	   this.dialogVisible = true;
	   this.srcList = []
	   this.dialogImageUrl =''
	   console.log(this.$refs.inputFile.files[0])
	   this.$refs.inputFile.value = ''
   }
   
  //  handleAvatarSuccess(obj,  file, fileList) {
	 //   // this.imageUrl = require('../../assets/modelBg.jpg');
	 //   this.dialogVisibleBtn = true;
	 //   this.dialogVisible = true;
  //    // console.log(obj,  file, fileList);
	 // var _this = this;
	 //  _this.srcList=[]
	 //   // _this.imageUrl =''
	 //  if(file.status === "success"){
	 // const fr = new FileReader();
	 //     fr.readAsDataURL(file.raw);
	 //    fr.onload = function(){
	 //      // console.log(fr.result);
	 // 	   _this.imageUrl = fr.result;
	 // 	    _this.srcList.push(_this.imageUrl)
	 // 		_this.dialogVisibleBtn = false;
		// 	_this.loading = false;
	 // 	   }
		//    if(obj.success === true){
		//    		 _this.loading = false;
		//    		_this.dialogImageUrl = obj.url;
		//    		_this.fileName =obj.filename;
		//    		// this.dialogVisible =false
		//    		_this.fileList.push(obj);
		//    }
	 //    }
  //  },
  },
};
</script>

<style scoped lang="less">
	input {
			  /* 隐藏默认的"打开文件"样式 */
			  display: none;
			}
.model{
	background: #fff;
}
.model_box{
	width: 1200px;
	margin: auto;
	padding: 50px 0;
}
.model_title{
	width: 100%;
	display: flex;
	justify-content: space-between;
	border-bottom: 1px solid;
	div{
		font-size: 18px;
		margin-bottom: 22px;
		img{
			width: 30px;
			height: 30px;
			vertical-align: middle;
			margin-right: 10px;
		}
	}
}
.model_content{
	width: 970px;
	height: 700px;
	margin: auto;
	margin-top: 50px;
	position: relative;
	// background: url('../../assets/modelBg.jpg');
	// background-size: 100% 100%;
}
.model_img{
	position: absolute;
	left: 0;
	top: 0;
	width: 270px;
	height: 200px;
	background: #eee;
	p{
		text-align: center;
		line-height: 200px;
		font-size: 14px;
		color: #A2A2A2;
	}
}
.model_upload{
	width: 60px;
	height: 40px;
	box-shadow: 0px 4px 6px 0px rgba(21, 126, 251, 0.3);
	border-radius: 20px;
	border: 1px solid #157EFB;
	position: absolute;
	right: 20px;
	top: 20px;
	text-align: center;
	line-height: 40px;
	z-index: 1;
}
.upload-demo{
	position: absolute;
	bottom: 50px;
	left: 42%;
	z-index: 1;
}
.upload-demo1{
	position: absolute;
	top: 10px;
	right: 5%;
	z-index: 1;
	font-size: 30px;
	cursor: pointer;
	color: #157EFB;
}
.upload_Btn{
	width: 170px;
	height: 40px;
	border-radius: 20px;
	background: #157EFB;
	border: none;
	color: #fff;
	}
.model_stl{
	width: 100%;
	height: 100%;
}
.flex{
	display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/model/modelImage.vue